/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Hero_CtaInputs */

const en_homepage_hero_cta = /** @type {(inputs: Homepage_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const es_homepage_hero_cta = /** @type {(inputs: Homepage_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Homepage_Hero_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_hero_cta = /** @type {((inputs?: Homepage_Hero_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Hero_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_hero_cta(inputs)
	return en_homepage_hero_cta(inputs)
});